const wrapper = "_275w18xcp6k";
const container = "_275c1wu78w3";
const backgroundGraphic = "_275be0qyy3";
const heading = "_275h1qq4boi";

export { backgroundGraphic, container, heading, wrapper };
import "./_portal-page.style.linaria.module.css";
//# sourceMappingURL=_portal-page.style.js.map
